
import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FilterCollection } from '@/stores/filter.store';
import WatchlistInnerTabNavigation from '@/components/watchlist/WatchlistInnerTabNavigation.vue';
import { CollectionType } from '@/enums/collection-type';
import { TabType } from '@/interfaces/inner-tabs';
import { TvShowTrackingType } from '@/@types/graphql-types';
import { ModalHelper } from '@/helpers/modal-helper';
import { AccountModal } from '@/lazy-load-components';
import { ListsCollectionType } from '@/stores/routing.store';

export const TVShowTrackingList = () =>
	import(
		/* webpackChunkName: "tv-show-tracking-list" */ '@/components/watchlist/tv-show-tracking/TVShowTrackingList.vue'
	);
export const BasicButton = () => import(/* webpackChunkName: "basic-button" */ '@/ui-components/BasicButton.vue');
const ListsEmptyPlaceholder = () =>
	import(/* webpackChunkName: "lists-empty-placeholder" */ '@/components/watchlist/ListsEmptyPlaceholder.vue');

const Filter = namespace('filter');
const User = namespace('user');
const Routing = namespace('routing');

@Component({
	name: 'TVShowTracking',
	components: {
		TVShowTrackingList,
		WatchlistInnerTabNavigation,
		BasicButton,
		ListsEmptyPlaceholder,
	},
})
export default class TVShowTracking extends Vue {
	@Routing.Action setLastActiveListsCollectionType: (lastActiveListsCollectionType: ListsCollectionType) => void;
	@Filter.Getter(CollectionType.TV_SHOW_TRACKING) filterListsTracking: FilterCollection;
	@User.Getter isLoggedIn: () => boolean;

	@Emit('scrollToTop')
	scrollToTop() {}
	get innerTabs() {
		return [
			{
				key: TabType.CONTINUE_WATCHING,
				translation: this.$tc('WEBAPP_SUBHEADING_CONTINUE_WATCHING'),
			},
			{
				key: TabType.HAVENT_STARTED,
				translation: this.$tc('WEBAPP_SUBHEADING_NOT_STARTED'),
			},
			{
				key: TabType.CAUGHT_UP,
				translation: this.$tc('WEBAPP_WATCHLIST_TAB_ALL'),
			},
		] as const;
	}

	created() {
		this.setLastActiveListsCollectionType(CollectionType.TV_SHOW_TRACKING);
	}

	get innerTabFilter() {
		return this.filterListsTracking.inner_tab || TabType.CONTINUE_WATCHING;
	}

	get tvShowTrackingType() {
		switch (this.innerTabFilter) {
			case TabType.HAVENT_STARTED:
				return TvShowTrackingType.NotStarted;
			case TabType.CONTINUE_WATCHING:
				return TvShowTrackingType.ContinueWatching;
			case TabType.CAUGHT_UP:
				return TvShowTrackingType.CaughtUp;
		}
	}

	openAccountModal() {
		ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'account-modal' }, 'Collections');
	}
}
